<template>
    <v-dialog max-width="500px" v-model="inDialog" env_index persistent>
        <v-card>
            <v-form ref="createForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Chỉ số')"
                                v-model.trim="item.envName"
                                name="envName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('envName')"
                                :data-vv-as="$t('Chỉ số')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Đơn vị')"
                                v-model.trim="item.unitType"
                                name="unitType"
                                maxLength="250"
                                :error-messages="errors.first('unitType')"
                                :data-vv-as="$t('Đơn vị')"
                            ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs12>
                            <v-select
                                :items="units"
                                :label="$t('Đơn vị')"
                                v-model="item.unitTypeId"
                                name="unitTypeId"
                                item-value="categoryId"
                                item-text="categoryName"
                                v-validate="'required'"
                                :data-vv-as="$t('Đơn vị')"
                                :error-messages="errors.first('unitTypeId')"
                                :disabled="item.envId"
                            />
                        </v-flex> -->
                        <!-- <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Giá trị cho phép')"
                                v-model.trim="item.maxValue"
                                name="maxValue"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('maxValue')"
                                :data-vv-as="$t('Giá trị cho phép')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Giá trị trung bình')"
                                v-model.trim="item.mediumValue"
                                name="mediumValue"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('mediumValue')"
                                :data-vv-as="$t('Giá trị trung bình')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Giá trị tối thiểu')"
                                v-model.trim="item.minValue"
                                name="minValue"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('minValue')"
                                :data-vv-as="$t('Giá trị tối thiểu')"
                            ></v-text-field>
                        </v-flex> -->
                        <v-flex xs12>
                            <v-select
                                :items="lstStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                v-validate="'required'"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "env-index-create",
    components: { message, axios },
    props: {
        envIndex: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        units: {
            type: Array,
            default: [],
        },
    },
    data: () => {
        return {
            inDialog: false,
            lstStatus: cateContants.areaStatus,
            item: {
                envName: "",
                maxValue: 0,
                mediumValue: 0,
                minValue: 0,
                status: 1,
                unitTypeId: 0,
                unitType: "",
            },
        };
    },
    computed:{
        formName(){
            if(this.item.envId != undefined && this.item.envId != null){
                return "Cập nhật chỉ số môi trường";
            } else {
                return "Thêm mới chỉ số môi trường";
            }
        }
    },
    watch: {
        envIndex: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    this.item = {
                        envId: value.envId,
                        envName: value.envName,
                        maxValue: value.maxValue ? value.maxValue : 0,
                        mediumValue: value.mediumValue ? value.mediumValue : 0,
                        minValue: value.minValue ? value.minValue : 0,
                        status: value.status ? value.status : 0,
                        unitTypeId: value.unitTypeId ? value.unitTypeId : 0,
                        unitType: value.unitType ? value.unitType : "",
                    };
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                envName: "",
                maxValue: 0,
                mediumValue: 0,
                minValue: 0,
                status: 1,
                unitTypeId: 0,
                unitType: "",
            };
            this.$validator.reset();
        },
        onCancel: function () {
            this.$emit("closeEnvDialog", "");
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/envIndex/save",
                        this.item
                    )
                    .then(
                        (data) => {
                            console.log(data);
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
    },
    created() {},
};
</script>
